import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import speakerIcon from '../../../assets/icons/speaker.svg'

class Broadcast extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { classes, merchant } = this.props
    if (!merchant) return null
    const broadcasts = []
    if (merchant.setting.directoryBroadcastMessage) {
      broadcasts.push(merchant.setting.directoryBroadcastMessage)
    } else {
      return <React.Fragment></React.Fragment>
    }

    function getStringLength (str) {
      return str.replace(/[^\\x00-\xff]/g, 'xx').length
    }

    function calculateMarqueeSpeed (baseLength, baseTime) {
      const totalLength = broadcasts.reduce((acc, message) => acc + getStringLength(message), 0)
      const ratio = totalLength / baseLength
      const marqueeSpeed = ratio < 1 ? baseTime : ratio * baseTime
      return marqueeSpeed
    }

    const marqueeSpeed = calculateMarqueeSpeed(50, 8)

    return (
      <div className={classes.broadcast}>
        <img src={speakerIcon} alt='speaker_icon' className={classes.icon} />
        <div className={classes.marquee}>
          <ul style={{ animation: `marquee ${marqueeSpeed}s linear infinite` }}>
            {broadcasts.map((message, index) => <li key={index} className={classes.text}>{message}</li>)}
          </ul>
        </div>
      </div>
    )
  }
}

const styles = {
  broadcast: {
    display: 'flex',
    borderRadius: 4,
    backgroundColor: '#EBBD3F',
    fontSize: 17,
  },
  icon: {
    padding: 8,
  },
  '@keyframes marquee': {
    from: {
      left: '100%',
      transform: 'translateX(0%)',
    },
    to: {
      left: '0%',
      transform: 'translateX(-100%)',
    },
  },
  marquee: {
    position: 'relative',
    flex: 1,
    overflow: 'hidden',

    '& > ul': {
      position: 'absolute',
      display: 'flex',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      lineHeight: '35px',
      '& > li': {
        whiteSpace: 'nowrap',
        marginRight: '2em',
      },
    },
  },

  text: {
    marginRight: 200,
    color: '#000000',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(Broadcast)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Broadcast.jsx